export default {
  ACCOUNT: 'ACCOUNT',
  BILLING: 'BILLING',
  PROFILE_MANAGEMENT: 'PROFILE_MANAGEMENT',
  SUBSCRIPTION: 'SUBSCRIPTION',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  SERVICES: 'SERVICES',
  WORKFLOW: 'WORKFLOW',
  WORKFLOW_MANAGEMENT: 'WORKFLOW_MANAGEMENT',
  CARD_DISPLAY: 'CARD_DISPLAY',
  LABS: 'LABS',
  OVERVIEW: 'OVERVIEW',
  REWARDS_CONFIGURATION: 'REWARDS_CONFIGURATION',
  STORAGE: 'STORAGE',
  CASE_TEAM: 'CASE_TEAM',
  ADD_ONS: 'ADD_ONS',
} as const
